import { NavLink, Outlet } from "react-router-dom";
import { Link } from "react-router-dom";
import { useAuth } from "@itaas/core/auth/useAuth";
import { ModuleLogoutButton } from "@itaas/core/auth/ModuleLogoutButton";
import { visiblePlatformMenuItems } from "@/navigation/platform-menu.config";
import { routes } from "@/router/all_routes";

export function PlatformLayout() {
  const { user, tenant } = useAuth();
  const menuItems = visiblePlatformMenuItems(user);

  const displayName =
    user?.displayName?.trim() ||
    [user?.firstName, user?.lastName].filter(Boolean).join(" ").trim() ||
    user?.email ||
    "Utilisateur";

  return (
    <div className="suite-platform-layout">
      <aside className="suite-platform-sidebar" aria-label="Navigation plateforme">
        <div className="suite-platform-sidebar__brand">
          <Link to={routes.modules} className="suite-platform-sidebar__home">
            ITaaS Suite
          </Link>
          <p className="suite-platform-sidebar__tagline mb-0">Plateforme</p>
        </div>

        <nav className="suite-platform-sidebar__nav">
          {menuItems.map((item) => (
            <NavLink
              key={item.id}
              to={item.path}
              className={({ isActive }) =>
                `suite-platform-sidebar__link${isActive ? " suite-platform-sidebar__link--active" : ""}`
              }
              end={item.path === routes.platform}
            >
              <span className="suite-platform-sidebar__link-label">{item.label}</span>
              <span className="suite-platform-sidebar__link-desc">{item.description}</span>
            </NavLink>
          ))}
        </nav>

        <div className="suite-platform-sidebar__footer">
          <p className="suite-platform-sidebar__user mb-1">{displayName}</p>
          {tenant?.name ? (
            <p className="suite-platform-sidebar__tenant mb-2">{tenant.name}</p>
          ) : null}
          <Link to={routes.modules} className="btn btn-sm btn-outline-secondary w-100 mb-2">
            Modules métier
          </Link>
          <ModuleLogoutButton className="btn btn-sm btn-outline-danger w-100" />
        </div>
      </aside>

      <main className="suite-platform-main">
        <Outlet />
      </main>
    </div>
  );
}
